<template>
    <div class="lawsuit_serve" v-loading="loading">
        <div class="box1">
            <div class="title_box">
                <div class="borders"></div>
                <div class="titles">
                    律师服务
                </div>
            </div>
            <div class="list_flex">
                <div class="items" v-for="(item,index) in sever_list" :key="index" @click="handle_sever(item)">
                    <div class="imgs">
                        <!-- <img src="../../../assets/img/index/legal/bg1.png" alt=""> -->
                         <img :src="item.thumb" alt="">
                    </div>
                    <div class="item_title">{{ item.title }}</div>
                    <div class="item_tages">
                        <div class="tage" v-if="(item.cate1||{}).title ">{{ item.cate1.title }}</div>
                        <div class="tage" v-if="(item.cate2||{}).title ">{{ item.cate2.title  }}</div>
                        <div class="tage" v-if="(item.cate3||{}).title ">{{ item.cate3.title  }}</div>
                    </div>
                    <div class="price_flex">
                        <div class="price">{{ item.price }}</div>
                        <div class="nums">销量{{ item.sale_num }}</div>
                    </div>
                </div>
                <div class="items2" v-for="(item,index) in 4-(sever_list.length)"></div>
            </div>
        </div>
        <div class="box2">
            <div class="title_box">
                <div class="borders"></div>
                <div class="titles">
                    案例点评
                </div>
            </div>
            <div class="list_flex">
                <div class="items" v-for="(item,index) in casse_list" :key="index" @click="handle_detial(item.case)">
                    <div class="item_titles">
                        {{item.case.title}}
                    </div>
                    <div class="item_texts">
                       {{ item.case.desc }}
                    </div>
                </div>
            </div>
        </div>
        <div class="box3">
            <div class="title_box">
                <div class="borders"></div>
                <div class="titles">
                    用户评价（<span>{{ count }}</span>）
                </div>
            </div>
            <div class="fraction">
                <div class="fraction_box">
                    <div class="nums">{{ stat }}</div>
                    <div class="pl_star">
                        <div class="star_text">综合评价</div>
                        <div class="star_num">
                            <div class="star_item" v-for="(item,index) in 5" :key="index">
                                <img src="@/assets/img/index/legal/plx_ac.png" v-if="index<stat" alt="" >
                                <img src="@/assets/img/index/legal/plx_no.png" v-if="index>=stat" alt="" >
                            </div>
                        </div>
                    </div>
                </div>
                <div class="check_box">
                    <div class="check_title">律师印象</div>
                    <div class="check_flex">
                        <div class="check_item" v-for="(item,index) in tage_list" :key="index">
                            {{item.name}}（{{item.num}}）
                        </div>
                    </div>
                </div>
                <div class="pl_list_box">
                    <div class="item_box" v-for="(item,index) in lspl_list" :key="index">
                        <div class="user_flex">
                            <div class="images">
                                <img src="@/assets/img/index/legal/user_pl_img.png" alt="" v-if="!item.user_info.image">
                                <img :src="item.user_info.image" alt="" v-if="item.user_info.image">
                            </div>
                            <div class="user_info">
                                <div class="user_name">{{ item.user_info.name }}</div>
                                <div class="user_time">{{ item.creatTime }}</div>
                            </div>
                        </div>
                        <div class="pl_info">
                            <div class="pl_star_num">
                                <div class="star_item" v-for="(items,indexs) in 5" :key="indexs">
                                    <img src="@/assets/img/index/legal/plx_ac.png" v-if="indexs<item.star" alt="" >
                                    <img src="@/assets/img/index/legal/plx_no.png" v-if="indexs>=item.star" alt="" >
                                </div>
                            </div>
                            <div class="tage_list">
                                <div class="item_tage" v-for="(items,indexs) in item.tag" :key="indexs">
                                    {{ items }}
                                </div>
                            </div>
                            <div class="texts">{{ item.content }}</div>
                            <!-- <div class="address">发布于&nbsp;北京</div> -->
                        </div>
                    </div>
                    <div class="btns_flex" v-if="count>10">
                        <div class="btns">
                            查看全部{{count}}条评论
                            <img src="@/assets/img/index/legal/rights1.png" alt="" >
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'



export default {
    components: {
        
    },
    props:['ls_detial'],
//    ls_detial:{
//            type: Object,
//            default: {},
//        },
    name: "homes",
    data() {
        return {
            loading:false,
            sever_list:[],
            casse_list:[],
            lspl_list:[],
            tage_list:[],
            limit:10,
            count:0,
            stat:0,
        }
    },
    computed: {
       
    },
    watch: {
        ls_detial(){
            console.log('ls_detial',this.ls_detial)
            this.get_sevsr_list()

        },
    },
    created() {
      
    },
    mounted() {
        this.get_casse_list()
        this.get_pl_list()
        if(this.ls_detial){
            this.get_sevsr_list()

        }
    },
    methods: {
        get_sevsr_list(){
            this.$api("servePros", {
                limit:4,
                causeIds:this.ls_detial.causeIds
			}, "get").then((res) => {
                this.loading = false
                console.log('律师服务',res)
                if (res.code == 1) {
                    this.sever_list=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_casse_list(){
            this.$api("lawyerCaseCommentList", {
                limit:4,
                status:20,
                showId:this.$route.query.user_id,
			}, "get").then((res) => {
                this.loading = false
                console.log('案例点评列表',res)
                if (res.code == 1) {
                    this.casse_list=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_pl_list(){
            this.$api("lawyersInfoCommentsList", {
                id:this.$route.query.id,
                page:1,
                limit:this.limit,
			}, "get").then((res) => {
                this.loading = false
                console.log('律师评论',res)
                if (res.code == 1) {
                  this.count=res.data.count
                  this.tage_list=res.data.tage_num
                  this.lspl_list=res.data.list
                  this.stat=res.data.stat.toFixed(0)
                  this.lspl_list.forEach((e)=>{
                    if(e.tag){
                        e.tag=e.tag.split(',')
                    }
                  })
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_sever(item){
            console.log('item',item)

            if(item.type==1){
                this.$router.push({
                    path:'/individual_detial',
                    query:{
                        id:item.id,
                        lawyer_id:this.$route.query.lawyer_id,

                    }
                })
            }else{
                this.$router.push({
                    path:'/enterprise_detial',
                    query:{
                        id:item.id,
                        lawyer_id:this.$route.query.lawyer_id,

                    }
                })
            }
         
        },
        handle_detial(item){
            this.$router.push({
                path:'/comments_detial',
                query:{
                    id:item.id
                }
            })
        },
    },

}
</script>
<style scoped lang="less">
.lawsuit_serve{
    padding-top: 24px;
    .title_box{
        display: flex;
        // align-items: center;
        padding-top: 24px;
        padding-right: 32px;
        .borders{
            width: 4px;
            height: 22px;
            background: #377CFD;
            border-radius: 3px 3px 3px 3px;
        }
        .titles{
            flex: 1;
            // padding-left: 32px;
            margin-left: 28px;
            padding-bottom: 24px;
            border-bottom: 1px solid #D7D7D7;

            
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            span{
                color: #377CFD;
            }
        }
    }
    .box1{
        height: 519px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .list_flex{
            display: flex;
            align-items: center;
            // flex-wrap: wrap;
            justify-content: space-between;
            padding: 32px;
            .items2{
                width: 320px;

            }
            .items{
                width: 320px;
                height: 380px;
                cursor: pointer;
                .imgs{
                    width: 320px;
                    height: 240px;
                    img{
                        width: 320px;
                        height: 240px;
                    }
                }
                .item_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 18px;
                    color: #333333;
                    padding-top: 16px;
                }
                .item_tages{
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    padding-top: 16px;
                    .tage{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 12px;
                        color: #FFAA00;
                        border: 1px solid #FFAA00;
                        margin-right: 10px;
                        padding: 4px 12px;
                        border-radius: 8px;
                        background: #FDF6EC;
                    }

                }
                .price_flex{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-top: 20px;
                    .price{
                                            
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 32px;
                        color: #FD4C5C;

                    }
                    .nums{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #999999;
                    }
                }
            }
            
        }
    }
    .box2{
        width: 1440px;
        height: 531px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        margin-top: 23px;
        .list_flex{
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 32px;
            .items{
                width: 672px;
                height: 170px;
                background: #FFFFFF;
                border-radius: 8px 8px 8px 8px;
                border: 1px solid #B8C4D1;
                margin-bottom: 35px;
                padding: 32px 32px 44px 32px;
                cursor: pointer;
                .item_titles{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 20px;
                    color: #333333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                }
                .item_texts{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    padding-top: 20px;
                }
            }
        }
    }
    .box3{
        width: 1440px;
        height: 886px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        margin-top: 29px;
        .fraction{
            padding: 0 32px;
            .fraction_box{
                padding: 13px 0 17px 33px;
                display: flex;
                align-items: center;
                .nums{
                    font-family: Source Han Sans SC, Source Han Sans SC;
                    font-weight: 500;
                    font-size: 40px;
                    color: #333333;
                }
                .pl_star{
                    padding-left: 16px;
                    .star_text{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 12px;
                        color: #999999;
                    }
                    .star_num{
                        display: flex;
                        align-items: center;
                        img{
                            width: 21px;
                            height: 21px;
                        }
                    }
                }

            }
            .check_box{
                display: flex;
                align-items: center;
                width: 1376px;
                // height: 88px;
                background: #F5F5F5;
                border-radius: 0px 0px 0px 0px;
                padding: 28px 32px;
                .check_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    // padding-right: 57px;
                    width: 100px;
                    margin-bottom: 10px;
                }
                .check_flex{
                    display: flex;
                    // align-items: center;
                    flex-wrap: wrap;
                    .check_item{
                        padding: 8px 12px;
                        background: #FFFFFF;
                        border-radius: 0px 0px 0px 0px;
                        border: 1px solid #D7D7D7;

                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 12px;
                        color: #999999;
                        margin-right: 16px;
                        margin-bottom: 10px;
                    }
                }

            }
            .pl_list_box{
                .item_box{
                    padding: 20px 32px;
                    border-bottom: 1px solid #D5D8DE;
                    display: flex;
                    // align-content: end;
                    .user_flex{
                        display: flex;
                        height: 64px;
                        align-items: center;
                        .images{
                            img{
                                width: 64px;
                                height: 64px;
                            }
                        }
                        .user_info{
                            padding-left: 24px;
                            .user_name{
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                            }
                            .user_time{
                                font-weight: 400;
                                font-size: 12px;
                                color: #666666;
                                margin-top: 8px;
                            }
                        }
                    }
                    .pl_info{
                        padding-left: 100px;
                        .pl_star_num{
                            display: flex;
                            align-items: center;
                            .star_item{
                                img{
                                    width: 21px;
                                    height: 21px;
                                }
                            }
                        }
                        .tage_list{
                            display: flex;
                            align-items: center;
                            padding-top: 16px;
                            padding-bottom: 20px;
                            .item_tage{
                                background: #FFFFFF;
                                border-radius: 0px 0px 0px 0px;
                                border: 1px solid #D7D7D7;
                                padding: 4px 11px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 12px;
                                color: #999999;
                                margin-right: 10px;
                            }  
                        }
                        .texts{
                            width: 1000px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                        }
                        .address{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 12px;
                            color: #999999;
                            padding-top: 20px;
                        }
                    }
                   
                }
                .btns_flex{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding-top: 32px;
                    .btns{
                        display: flex;
                        align-items: center;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #999999;
                        cursor: pointer;
                        img{
                            width: 16px;
                            height: 16px;
                            margin-left: 6px;
                        }
                    }
                }
            }

        }
    }
    
}

</style>